import { useLocation, useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

const TOOL_CONTEXT: Record<string, string> = {
  "/app/keyword-research": "I'm using Keyword Research and need help finding the right keywords for my niche.",
  "/app/nexis-ai": "I'm using Nexis AI and need help with my video script.",
  "/app/monetization-ai": "I'm using Monetisation AI and need help building a digital product.",
  "/app/sales-page-builder": "I'm using the Sales Page Builder and need help writing my sales copy.",
  "/app/email-list-builder": "I'm using the Email List Builder and need help creating my email funnel.",
  "/app/launch-advisor": "I'm using the Launch Advisor and need help planning my product launch.",
  "/app/clip-ai": "I'm using Clip AI and need help with my video clips.",
};

// Pages where the floating button should NOT appear (AskFint itself, dashboard, etc.)
const HIDDEN_ROUTES = ["/app/askfint", "/app/dashboard", "/app"];

export function FloatingAskFint() {
  const location = useLocation();
  const navigate = useNavigate();

  // Don't show on AskFint itself or non-tool pages
  const isHidden = HIDDEN_ROUTES.some((r) => location.pathname === r);
  const isAppRoute = location.pathname.startsWith("/app/");
  if (isHidden || !isAppRoute) return null;

  const handleClick = () => {
    // Find matching context for current path
    const contextEntry = Object.entries(TOOL_CONTEXT).find(([path]) =>
      location.pathname.startsWith(path)
    );
    const context = contextEntry?.[1] || "I need help with the platform.";
    navigate(`/app/askfint?context=${encodeURIComponent(context)}`);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={handleClick}
            size="lg"
            className="w-12 h-12 rounded-full shadow-lg bg-primary hover:bg-primary/90 text-primary-foreground p-0"
          >
            <MessageCircle className="w-5 h-5" />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left">
          <p className="text-xs">Ask Fint for help</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
